﻿import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';

import {connect} from 'react-redux';

import definitions from '../../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../../Style/cssHelpers';

import {getChildGenderLabel, getInsuranceMeta} from '../../../DataHelpers/lfDataHelpers';

class PossessionHeading extends React.Component {
    render() {

        const possession = this.props.possession;
        const insuranceMeta = getInsuranceMeta(possession.insuranceName);
        const hasInsuranceMeta = typeof insuranceMeta !== 'undefined' && insuranceMeta;



        if (hasInsuranceMeta && insuranceMeta.groupName === 'child') {
            const childGender = getChildGenderLabel(possession.childGender).toLowerCase();
            const childBirthData = possession.childPersonalIdentityNumber
                ? possession.childPersonalIdentityNumber
                : moment(possession.childBirthDate).format('YYYY-MM-DD');

            return (
                <div>
                    <InsuranceName>{possession.displayName}</InsuranceName>
                    <SubLabel>
                        {possession.childFirstName
                            ? possession.childFirstName
                            : '(Förnamn ej angivet)'
                        } {possession.childLastName}<br />(Kön: {childGender}, {childBirthData})
                    </SubLabel>
                </div>
            );
        }

        if (hasInsuranceMeta && insuranceMeta.groupName === 'dog'
            || hasInsuranceMeta && insuranceMeta.groupName === 'dog-life')
        {
            const dogBreeds = this.props.data.breedsById.dog;

            const dogName = possession.animalDisplayName;
            const dogBreedId = possession.animalBreedId;
            const dogBreed = dogBreedId in dogBreeds
                ? dogBreeds[dogBreedId]
                : 'Okänd ras';

            return (
                <div>
                    <InsuranceName>{possession.displayName}</InsuranceName>
                    <SubLabel>
                        {dogName ? dogName : '(Namn ej angivet)'} ({dogBreed})<br />
                    </SubLabel>
                </div>
            );
        }

        if (hasInsuranceMeta && insuranceMeta.groupName === 'cat'
            || hasInsuranceMeta && insuranceMeta.groupName === 'cat-life')
        {
            const catBreeds = this.props.data.breedsById.cat;

            const catName = possession.animalDisplayName;
            const catBreedId = possession.animalBreedId;
            const catBreed = catBreedId in catBreeds
                ? catBreeds[catBreedId]
                : 'Okänd ras';

            return (
                <div>
                    <InsuranceName>{possession.displayName}</InsuranceName>
                    <SubLabel>
                        {catName ? catName : '(Namn ej angivet)'} ({catBreed})<br />
                    </SubLabel>
                </div>
            );
        }


        if (hasInsuranceMeta && insuranceMeta.groupName === 'small-animal') {
            const smallAnimalBreeds = this.props.data.breedsById.smallanimal;

            const animalName = possession.animalDisplayName;
            const animalBreedId = possession.animalBreedId;
            const animalType = animalBreedId in smallAnimalBreeds
                ? smallAnimalBreeds[animalBreedId]
                : 'Okänt djur';

            return (
                <div>
                    <InsuranceName>{possession.displayName}</InsuranceName>
                    <SubLabel>
                        {animalName ? animalName : '(Namn ej angivet)'} ({animalType})<br />
                    </SubLabel>
                </div>
            );
        }
        return possession.displayName;
    }
}

// state

const mapStateToProps = (state) => {
    return {
        data: state.startPageData
    };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PossessionHeading);

// styles

const InsuranceName = styled.h3`
    font-size: inherit;
    margin-bottom: 10px;
    &:nth-of-type(2) {
        margin-bottom: 0px;
    }
`;

const SubLabel = styled.p`
    display: block;
    margin: 0px;
    color: white;
    font-size: inherit;
    font-weight: normal;

    ${mediaQuery.medium(`
        font-size: 14px;
    `)}
`;
